import React from "react";
import './styles.css'

const Sobre = () => {
	return (<a href='#to-do' className='sobre'>Sobre</a>);
}

export default Sobre;